import { getToday } from '@/common/functions/getToday';
import { useRef, useState } from 'react';

const useSearchBox = ({ handleSearchCallback }) => {
	const today = getToday();

	const dateFromRef = useRef();
	const dateToRef = useRef();

	const [selectedDomain, setSelectedDomain] = useState();
	const [selectedTest, setSelectedTest] = useState();
	const [selectedEventSource, setSelectedEventSource] = useState();
	const [selectedEventTarget, setSelectedEventTarget] = useState();

	const handleSearch = (e) => {
		e.preventDefault();
		const browserPersonDayFrom = new Date(
			dateFromRef.current.value,
		).toISOString();
		const browserPersonDayTo = new Date(dateToRef.current.value).toISOString();
		const domain = selectedDomain?.value;
		const test = selectedTest.value;
		const eventSource = selectedEventSource.value;
		const targetSource = selectedEventTarget.value;

		handleSearchCallback(
			browserPersonDayFrom,
			browserPersonDayTo,
			domain,
			eventSource,
			targetSource,
			test,
		);
	};

	return {
		today,
		dateFromRef,
		dateToRef,
		handleSearch,
		selectedDomain,
		setSelectedDomain,
		selectedTest,
		setSelectedTest,
		selectedEventSource,
		setSelectedEventSource,
		selectedEventTarget,
		setSelectedEventTarget,
	};
};

export default useSearchBox;
